import { render, staticRenderFns } from "./AuthRegisterForm.vue?vue&type=template&id=1b86f6c9&scoped=true&"
import script from "./AuthRegisterForm.vue?vue&type=script&lang=js&"
export * from "./AuthRegisterForm.vue?vue&type=script&lang=js&"
import style0 from "./AuthRegisterForm.vue?vue&type=style&index=0&id=1b86f6c9&lang=scss&scoped=true&"
import style1 from "./AuthRegisterForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b86f6c9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
